import React, { PropsWithChildren, useMemo } from "react";
import { useContext } from "react";
import useMeasure from "utils/hooks/useMeasure.ts";

const PageSizeProvider = ({ children }: PropsWithChildren) => {
  const [measureRef, pageSize] = useMeasure<HTMLDivElement>();

  const value = useMemo(() => {
    return { ...pageSize };
  }, [pageSize.height, pageSize.width]);

  const refContextValue = useMemo(() => {
    return {
      measureRef,
    };
  }, []);

  return (
    <PageSizeContext.Provider value={value}>
      <PageSizeRefContext.Provider value={refContextValue}>
        {children}
      </PageSizeRefContext.Provider>
    </PageSizeContext.Provider>
  );
};

export default PageSizeProvider;

export const PageSizeContext = React.createContext<
  | {
      height: number;
      width: number;
    }
  | undefined
>(undefined);

export const PageSizeRefContext = React.createContext<
  { measureRef: (node: HTMLDivElement) => void } | undefined
>(undefined);

export const usePageSize = () => {
  return useContext(PageSizeContext)!;
};

export const usePageSizeRef = () => {
  return useContext(PageSizeRefContext)!;
};
